
import * as config from '../config.json';
import {getFetch} from './fetch/fetch';
import {getAjax} from './ajax/ajax';
const debug = config.debug;

async function getHttp(url, auth) {
  return config.fetch ? await getFetch(url, auth) : await getAjax(url, auth);
}

export default {
  get: getHttp,
};
